import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  projectRoundID: null,
  projectID: null,
  projectName: '',
}

export const projectInfoSlice = createSlice({
  name: 'project-configuration-rfx',
  initialState,
  reducers: {
    setProjectRoundID: (state, action) => {
      state.projectRoundID = action.payload
    },
    setProjectID: (state, action) => {
      state.projectID = action.payload
    },
    setProjectName: (state, action) => {
      state.projectName = action.payload
    },
  },
})

export const { setProjectRoundID, setProjectID, setProjectName } = projectInfoSlice.actions

export default projectInfoSlice.reducer
